<template>
  <div class="MaintenancePriceChange">
    <Btn
      v-if="hasRole('>=SUPPORT')"
      class="xs"
      data-cy="changeMaintenancePrice"
      @click="isOpen = true">
      Keisti
    </Btn>
    <ModalCont v-if="isOpen" @close="close">
      <FormValidation class="change-modal" @submit="updateMaintenancePrice">
        <h3>Keisti priežiūros mokestį</h3>
        <p>
          Dabartinis mokestis: {{ reservation.maintenancePerKw | currency }}/kW
        </p>
        <p>
          Dabartinė metinė suma:
          {{ reservation.maintenanceAnnualTotal | currency }}
        </p>

        <Row>
          <Column :md="12">
            <Field
              data-cy="newMaintenancePerKw"
              label="Naujas mokestis už kW (€/kW/metai)"
              :min="0.01"
              required
              step="0.01"
              type="number"
              :value.sync="newMaintenancePerKw" />
          </Column>
        </Row>

        <Row v-if="newMaintenancePerKw > 0">
          <Column :md="12">
            <div class="calculated-total">
              <strong>
                Nauja metinė suma:
                <span data-cy="calculatedAnnualTotal">
                  {{ calculatedAnnualTotal | currency }}
                </span>
              </strong>
            </div>
          </Column>
        </Row>

        <Row>
          <Column :md="12">
            <Field
              data-cy="generateAmendment"
              :isSwitch="true"
              label="Generuoti sutarties priedą"
              type="checkbox"
              :value.sync="generateAmendment" />
          </Column>
        </Row>

        <Row>
          <Column :xs="6">
            <Btn class="secondary" type="button" @click="close">
              Atšaukti
            </Btn>
          </Column>
          <Column :xs="6">
            <Btn
              class="success"
              data-cy="saveMaintenancePrice"
              :disabled="!isValidPrice"
              :isLoading="isSaving"
              type="submit">
              Išsaugoti
            </Btn>
          </Column>
        </Row>
      </FormValidation>
    </ModalCont>
  </div>
</template>

<script>
import { actions, getters } from '@/views/utils'

export default {
  props: {
    reservation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
      isSaving: false,
      newMaintenancePerKw: this.reservation.maintenancePerKw,
      generateAmendment: true,
    }
  },
  computed: {
    isValidPrice() {
      return this.newMaintenancePerKw && this.newMaintenancePerKw > 0
    },
    calculatedAnnualTotal() {
      if (!this.isValidPrice) return 0
      return this.newMaintenancePerKw * this.reservation.capacity
    },
    ...getters('hasRole'),
  },
  methods: {
    close() {
      this.isOpen = false
      this.newMaintenancePerKw = this.reservation.maintenancePerKw
      this.generateAmendment = true
    },
    async updateMaintenancePrice() {
      if (!this.isValidPrice) return

      await this.$wrap(
        async () => {
          await this.PATCH_RESERVATION({
            id: this.reservation.id,
            maintenancePerKw: this.newMaintenancePerKw,
            maintenanceAnnualTotal: this.calculatedAnnualTotal,
            $skipAmendment: !this.generateAmendment,
          })
        },
        'isSaving',
        'Priežiūros mokestis pakeistas sėkmingai',
      )

      this.close()
    },
    ...actions('PATCH_RESERVATION'),
  },
}
</script>

<style lang="scss">
.MaintenancePriceChange {
  display: inline-block;
  margin-left: 0.5rem;

  .change-modal {
    padding: 1.5rem;
  }

  .calculated-total {
    background: rgba($success, 0.1);
    border: 1px solid rgba($success, 0.5);
    border-radius: 4px;
    margin-bottom: 1rem;
    padding: 0.75rem;
    text-align: center;

    span {
      color: $text-color;
      font-size: $h4;
    }
  }
}
</style>
